<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <!-- <h2>{{quests['data']?.title}}</h2> -->
                    <h2>{{ quest["title"] }}</h2>
                    <ul>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#blog">Quest</a></li>
                        <li>
                            <a (click)="goListQuests()">{{
                                questTypes["name"]
                            }}</a>
                        </li>
                        <li>{{ quest["title"] }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape">
        <div class="shape-1">
            <img src="assets/img/shape/1.png" alt="image" />
        </div>
        <div class="shape-2 rotateme">
            <img src="assets/img/shape/2.png" alt="image" />
        </div>
        <div class="shape-3">
            <img src="assets/img/shape/3.svg" alt="image" />
        </div>
        <div class="shape-4">
            <img src="assets/img/shape/4.svg" alt="image" />
        </div>
        <div class="shape-5">
            <img src="assets/img/shape/5.png" alt="image" />
        </div>
    </div>
</div>

<section class="single-blog-area pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-image">
                        <img
                            src="{{
                                quest['imagePath'] == null
                                    ? 'https://via.placeholder.com/750x400.png'
                                    : quest['imagePath']
                            }}"
                            id="main-img"
                            alt="Link ảnh sai"
                        />
                    </div>

                    <div class="article-content">
                        <div class="entry-meta pb-4">
                            <!-- <ul>
                                <li><span>Posted On:</span> <a routerLink="/">September 31, 2020</a></li>
                                <li><span>Posted By:</span> <a routerLink="/">John Anderson</a></li>
                            </ul> -->
                            <ul class="post-meta">
                                <li>
                                    <fa-icon
                                        [icon]="faLocationDot"
                                        class="icon_location"
                                    ></fa-icon>
                                    {{ filterCity }}
                                </li>
                                <li>
                                    <i class="fa fa-comments"></i>
                                    <a routerLink="/single-quest">
                                        <fa-icon
                                            [icon]="faStar"
                                            class="icon_star"
                                        ></fa-icon>

                                        <span
                                            *ngIf="
                                                quest['totalFeedback'] !=
                                                    null &&
                                                    quest['averageStar'] !=
                                                        null;
                                                else feedbackNull
                                            "
                                        >
                                            {{ quest["averageStar"] }} ({{
                                                quest["totalFeedback"]
                                            }}
                                        </span>
                                        <ng-template #feedbackNull>
                                            <span> 0 (0 </span>
                                        </ng-template>
                                        {{ "feedback" | translate }})
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="list-icon">
                            <div class="row">
                                <div class="col-lg-4 col-md-12 quotes1">
                                    <div class="quotes">
                                        <div class="quotes_icon">
                                            <fa-icon
                                                [icon]="faTag"
                                                class="icon_add"
                                                size="lg"
                                            ></fa-icon>
                                        </div>
                                        <div class="quotes_name">
                                            <b>{{ "Category" | translate }}:</b>
                                            {{ questTypes["name"] }}
                                        </div>
                                    </div>
                                    <!-- <p class="p_tag">{{questTypeName}}</p> -->
                                </div>
                                <div class="col-lg-4 col-md-12 quotes2">
                                    <div class="quotes">
                                        <div class="quotes_icon">
                                            <fa-icon
                                                [icon]="faRoad"
                                                size="lg"
                                            ></fa-icon>
                                        </div>
                                        <div class="quotes_name">
                                            <b>{{ "Distance" | translate }}:</b>
                                            {{ quest["estimatedDistance"] }} Km
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-12 quotes5">
                                    <div class="quotes">
                                        <div class="quotes_icon">
                                            <fa-icon
                                                [icon]="faLocationDot"
                                                size="lg"
                                            ></fa-icon>
                                        </div>
                                        <div class="quotes_name">
                                            <b
                                                >{{
                                                    "Locations" | translate
                                                }}:</b
                                            >
                                            {{ quest["countQuestItem"] }}
                                        </div>
                                    </div>
                                    <!-- <p class="p_location"></p> -->
                                </div>

                                <div class="col-lg-4 col-md-12 quotes4">
                                    <div class="quotes">
                                        <div class="quotes_icon">
                                            <fa-icon
                                                [icon]="faClock"
                                                size="lg"
                                            ></fa-icon>
                                        </div>
                                        <div class="quotes_name">
                                            <!-- {{ "AvaiableTime" | translate }}  -->
                                            <b>{{ quest["availableTime"] }}</b>
                                        </div>
                                    </div>
                                    <!-- <p class="p_time">
                                        {{ quest["availableTime"] }}
                                    </p> -->
                                </div>

                                <div class="col-lg-4 col-md-12 quotes6">
                                    <div class="quotes">
                                        <div class="quotes_icon">
                                            <fa-icon
                                                [icon]="faAward"
                                                size="lg"
                                            ></fa-icon>
                                        </div>
                                        <div class="quotes_name">
                                            <b
                                                >{{
                                                    "BeginningPoint"
                                                        | translate
                                                }}:</b
                                            >
                                            {{ beginningPoint | number }}
                                        </div>
                                    </div>
                                    <!-- <p class="p_point">{{ 3000 | number }}</p> -->
                                </div>
                                <div class="col-lg-4 col-md-12 quotes7">
                                    <div class="quotes">
                                        <div class="quotes_icon">
                                            <fa-icon
                                                [icon]="faHourglassStart"
                                                size="lg"
                                            ></fa-icon>
                                        </div>
                                        <div class="quotes_name">
                                            <b>{{ "Duration" | translate }}:</b>
                                            {{ quest["estimatedTime"] }}
                                            {{ "minute" | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h3 class="comments-title">
                            {{ "decription" | translate }}
                        </h3>
                        <div
                            class="quest_content"
                            [innerHtml]="quest['description']"
                        ></div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12 purchase-bg">
                <div class="single-pricing-table">
                    <div class="pricing-header">
                        <h3>{{ "purchase" | translate }}</h3>
                    </div>

                    <div class="price">
                        {{ price | number }} <sup>đ</sup>
                        <sub>/ {{ "perQuest" | translate }}</sub>
                    </div>

                    <ul class="pricing-features">
                        <li>
                            <div class="quantity col-lg-6 col-sm-12">
                                {{ "Questquantity" | translate }}
                            </div>
                            <!-- <label class="sr-only" for="inlineFormInputGroupUsername2">Username</label> -->
                            <div class="input-group col-lg-6 col-sm-12">
                                <div class="input-group-prepend">
                                    <button
                                        class="input-group-text minus"
                                        (click)="count_quantity('-')"
                                    >
                                        <fa-icon
                                            [icon]="faMinus"
                                            class="icon_minus"
                                        ></fa-icon>
                                    </button>
                                </div>
                                <input
                                    type="number"
                                    class="form-control"
                                    id="inlineFormInputGroupUsername2"
                                    value="{{ quantity }}"
                                    minlength="1"
                                    [(ngModel)]="quantity"
                                    name="quantity"
                                    (keyup)="keyUpTotal()"
                                />
                                <div class="input-group-prepend">
                                    <button
                                        class="input-group-text add"
                                        (click)="count_quantity('+')"
                                    >
                                        <fa-icon
                                            [icon]="faPlus"
                                            class="icon_add"
                                        ></fa-icon>
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="price total">
                        <div class="col-lg-6 col-sm-12 total_label">
                            <h5>{{ "total" | translate }}</h5>
                        </div>
                        <div class="col-lg-6 col-sm-12 total_number">
                            {{ total | number }} <sup>đ</sup>
                        </div>
                    </div>

                    <div class="pricing-btn">
                        <button
                            (click)="goPurchasePage()"
                            class="default-btn"
                            [disabled]="quantity <= 0 ? true : false"
                        >
                            {{ "btn_purchase" | translate }} <span></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="map pt-100">
            <h3 class="comments-title">
                {{ "BeginningPlace" | translate }}
                <span class="start_point">{{ quest["address"] }}</span>
            </h3>
            <app-goongmap></app-goongmap>
        </div>

        <div class="comments-area pt-5">
            <h3 class="comments-title">
                {{ "Comments" | translate }}
            </h3>

            <div class="d-flex pb-3 pt-3">
                <div class="starAverage_icon" >
                    <fa-icon
                        [icon]="faStar"
                        class="icon_star"
                        [size]="'4x'"
                    ></fa-icon>
                </div>

                <div class="ms-3" *ngIf="quest['totalFeedback'] != null && quest['averageStar'] != null, elseFeedbackEmpty">
                    <div class="starAverage_number" >
                        {{quest['averageStar'] | number : '1.1-2'}}
                    </div>

                    <span class="numFeedback"> {{quest['totalFeedback']}} {{ "feedback" | translate }} </span>
                </div>
                <ng-template #elseFeedbackEmpty>
                    <div class="ms-3">
                        <div class="starAverage_number" >
                            0
                        </div>

                        <span class="numFeedback"> 0 {{ "feedback" | translate }} </span>
                    </div>
                </ng-template>
            </div>

            <label *ngIf="customerQuestComment[0] == null">
                {{ "Msg_feedback" | translate }}
            </label>
            <span *ngIf="customerQuestComment[0] != null">
                <ol class="comment-list">
                    <!-- Quest chưa có Feedback -->

                    <li
                        class="comment"
                        *ngFor="let cmt of customerQuestComment"
                    >
                        <article class="comment-body">
                            <footer class="comment-meta">
                                <div class="comment-author vcard">
                                    <img
                                        src="{{
                                            cmt?.imagePath != null
                                                ? cmt?.imagePath
                                                : 'assets/img/default-avatar.png'
                                        }}"
                                        class="avatar"
                                        alt="img"
                                    />
                                    <b class="fn">
                                        {{ cmt?.name }}
                                    </b>

                                    <span class="says">says:</span>
                                </div>

                                <div class="comment-metadata">
                                    <!-- <fa-icon
                                        *ngFor="let item of rating"
                                        [icon]="faStar"
                                        class="icon_star"
                                    ></fa-icon> -->
                                    <ng-container [ngSwitch]="cmt?.rating">
                                        <ng-container *ngSwitchCase="0">
                                            <fa-icon *ngFor="let item of [1]" [icon]="faStar" class="icon_star"></fa-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="1">
                                            <fa-icon *ngFor="let item of [1]" [icon]="faStar" class="icon_star"></fa-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="2">
                                            <fa-icon *ngFor="let item of [1,2]" [icon]="faStar" class="icon_star"></fa-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="3">
                                            <fa-icon *ngFor="let item of [1,2,3]" [icon]="faStar" class="icon_star"></fa-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="4">
                                            <fa-icon *ngFor="let item of [1,2,3,4]" [icon]="faStar" class="icon_star"></fa-icon>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="5">
                                            <fa-icon *ngFor="let item of [1,2,3,4,5]" [icon]="faStar" class="icon_star"></fa-icon>
                                        </ng-container>

                                    </ng-container>
                                    &nbsp;
                                    <a>{{
                                        cmt?.createdDate | date: "medium"
                                    }}</a>
                                </div>
                            </footer>

                            <div class="comment-content">
                                <p [innerHtml]="cmt?.feedBack"></p>
                            </div>
                        </article>
                    </li>
                </ol>

                <div class="pricing-btn" *ngIf="!isReadAll && customerQuestComment?.length >= 5">
                    <button (click)="readAll()" class="default-btn">
                        {{ "btn_readmore" | translate }}
                    </button>
                </div>
            </span>
        </div>
    </div>
</section>

<!-- <app-subscribe></app-subscribe> -->
